import {cn} from '@bem-react/classname';

export const cnPromoPageCard = cn('PromoPageCard');
